<template>
  <div class="menu-config">
    <div class="page-card">
      <div class="d-fle">
        <el-input v-model="queryParams.name" class="search-input" clearable placeholder="请输入器械名或拼音码"></el-input>
        <el-input v-model="queryParams.part_name" class="search-input ml10" clearable placeholder="请输入部位名"></el-input>
        <el-button class="ml10 mb10" type="primary" size="small" @click="search()">查询</el-button>
        <el-button class="ml10 mb10" type="primary" size="small" @click="openEdit()">新建</el-button>
      </div>
      <el-table
        border
        :data="list"
        style="width: 100%;"
        >
        <el-table-column prop="name" align="center" label="器械类名"></el-table-column>
        <el-table-column prop="part_name" align="center" label="部位"></el-table-column>
        <el-table-column
            prop=""
            label="操作"
            align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="small" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination :queryParams="queryParams" :getList="getList"/>
    <el-dialog title="器械类" :visible.sync="showDetail" width="800px" append-to-body>
      <div class="d-flex left ml50">
        <label class="mr10 input90">器械类名：</label>
        <el-input class="input200" v-model="detail.name"></el-input>
      </div>
      <div class="d-flex left mt10 ml50" v-for="(i, d) in detail.list" :key="d">
        <label class="mr10 input90">{{d === 0 ? '部位：' : ''}}</label>
        <el-input class="input200" v-model="i.name" @blur="checkName(i, d)"></el-input>
        <el-button v-if="detail.list.length > 1" class="ml10" size="small" @click="handleDelItem(d)">删除</el-button>
        <el-button v-if="d === detail.list.length - 1" class="ml10" size="small" @click="handleAddItem()">添加</el-button>
      </div>
      
      <div class="d-flex right">
        <el-button class="mb10" type="primary" size="small" @click="save()" :disabled="saving">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import { instrumentPartList, instrumentPartCreate, instrumentPartUpdate, instrumentPartDelete } from '@/api.js'
import { pageSize } from '@/utils/Config'
export default {
  name: 'instrumentPart',
  components: {
    Pagination
  },
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0
      },
      list: [],
      showDetail: false,
      detail: {
        name: '',
        list: []
      },
      saving: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const { pageIndex, pageSize, name, part_name } = this.queryParams
      const query = {
        page: pageIndex,
        per_page: pageSize,
        name,
        part_name
      }
      this.$request('get', instrumentPartList, query)
      .then((res) => {
        if (res) {
          this.list = res.data
          this.queryParams._total = res.total
        }
      })
    },
    search() {
      this.queryParams.pageIndex = 1
      this.getList() 
    },
    openEdit(item = {}) {
      this.detail = item
      const { part_name, part_id } = item
      const part_name_arr = (part_name || '').split(',')
      const part_id_arr = (part_id || '').split(',')
      const part_arr = []
      part_id_arr.forEach((i, d) => {
        part_arr.push({
          id: i ? Number(i) : 0,
          name: part_name_arr[d]
        })
      })
      
      this.$set(this.detail, 'list', part_arr)
      this.showDetail = true
    },
    handleDel(item) {
      // 删除
      this.$confirm('删除器械类会使相关的器械设置为空，是否继续?')
      .then(() => {
        const { id } = item
        const url = `${instrumentPartDelete}/${id}`
        this.$request('post', url)
        .then((res) => {
          if (res) {
            this.$message.success('删除成功')
            this.getList()
          }
        })
      })
    },
    handleDelItem(index) {
      this.detail.list.splice(index, 1)
    },
    handleAddItem() {
      this.detail.list.push({
        name: '',
        id: 0
      })
    },
    handleList(list) {
      // 处理过滤数据
      const handled = []
      list.forEach(i => {
        i.name = i.name.replace(/ /g, '')
        if (i.name) {
          handled.push(i)
        }
      })

      return handled
    },
    checkName(i, index) {
      // 检查重复器械名
      if (this.detail.list.filter((d, di) => di !== index).filter((f) => f.name === i.name).length > 0) {
        this.$message.error('部位名不可重复')
        this.$set(i, 'name', '')
      }
    },
    save() {
      // 保存
      if (this.saving) return
      let url = instrumentPartCreate
      const { id } = this.detail
      if (id) {
        url = instrumentPartUpdate
      }

      const {
        name, list
      } = this.detail
      const handledName = (name || '').replace(/ /g, '')

      if (!handledName) {
        this.$message.error('请填写正确的器械类名')
        return
      }

      const handledList = this.handleList(list || [])

      if (handledList.length === 0) {
        this.$message.error('没有可以保存的部位')
        return
      }

      this.saving = true
      const params = {
        id: id || 0,
        name: handledName,
        part_lists: handledList
      }
      this.$request('post', url, params)
      .then((res) => {
        if (res) {
          this.$message.success('操作成功')
          this.showDetail = false
          this.getList()
        }

        setTimeout(() => {
          this.saving = false
        }, 500)
      })
    }
  }
}
</script>

<style>

</style>